import Crud from '../views/Movimento/Table'
import Entity from '../views/Movimento/Add'
import EntityView from '../views/Movimento/View'

let routes = {
    path: '/movimentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/movimentos/add',
            name: 'NewMovimento',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Movimentos',
                breadcrumb: [
                    {
                        text: 'Movimentos',
                        to: '/movimentos',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/movimentos/view/:id?',
            name: 'ViewMovimentos',
            component: EntityView,
            meta: {
                pageTitle: 'Ver Movimento',
                breadcrumb: [
                    {
                        text: 'Movimentos',
                        to: '/movimentos',
                        active: false,
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/movimentos',
            name: 'list-movimentos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Movimentos',
                breadcrumb: [
                    {
                        text: 'Movimentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
